import { useEffect, useState } from 'react';

/**
 * Minimal hash-based router. Returns the current hash without the leading "#"
 * (e.g. "/privacy" for "#/privacy", "features" for "#features", "" for none).
 * Avoids pulling in a routing dependency for a single extra page.
 */
export default function useHashRoute() {
  const read = () =>
    typeof window === 'undefined' ? '' : window.location.hash.replace(/^#/, '');

  const [route, setRoute] = useState(read);

  useEffect(() => {
    const onChange = () => setRoute(read());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return route;
}
